module.exports="#define GLSLIFY 1\nvarying vec2 vUv;\nvoid main()\n{\n\tgl_Position = vec4(uv * 2.0 - 1.0, 1.0, 1.0);\n\tvUv = uv;\n}";